import * as e from '@/api/utils/endpoints'
import axios from '@/plugins/axios'

export const fetchFeatures = () => axios.get(e.FEATURES)
